// style by theme by taking first word from theme prop
function getThemeClass (theme) {
  let themeClass = 'unknown'
  if (theme != null) {
    themeClass = theme.split(' ')[0].toLowerCase()
  }
  return themeClass
}

export default getThemeClass
